import React from "react";
import { Link } from "react-router-dom";

const FollowingCard = ({ following }) => {
  return (
    <>
      <tr className="border-b border-gray-200 hover:bg-gray-100">
        <td className="py-3 px-6 text-left">
          <div className="flex justify-center items-center">
            <div className="mr-2">
              <img
                className="w-6 h-6 rounded-full"
                src={following.avatar["url"]}
                alt="following-avatar"
              />
            </div>
          </div>
        </td>
        <td className="py-3 px-6 text-left">
          <div className="flex items-center">
            <Link
              className="text-indigo-700 "
              to={`/blog-by-user/${following._id}`}
            >
              <span>{following.fullName}</span>
            </Link>
          </div>
        </td>
        <td className="py-3 px-6 text-left">
          <div className="flex items-center">
            <span>{following.email}</span>
          </div>
        </td>
        <td className="py-3 px-6 text-center">
          <span className="bg-purple-200 text-purple-600 py-1 px-3 rounded-full text-xs">
            following
          </span>
        </td>
      </tr>
    </>
  );
};

export default FollowingCard;
